import moment from "moment";
// -
import {IconFillingColoured, IconTemperatureColoured} from "site-apps/assets/AssetColorsIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {CRITERIA_TITLES} from "./ModelsDynamic";

// Criterios del punto 5 que se pueden activar o no por contenedor (title: leyenda en el tooltip de la cabecera)
const CRITERIA = ["c1", "c2", "c3"];

const TabCriteriaTable = (
    {
        dynamicAssets,
        dynamicAssetsShow, setDynamicAssetsShow,
        checkedAll, setCheckedAll,
        items, setCounter, setActiveMassive,
        stepsTabs
    }
) => {

    const handleCheckAll = (e) => {
        let {checked} = e.target;
        let checkboxs = document.querySelectorAll("#dynamic-assets-table-body input[type='checkbox'].index-select");
        items.current.chosen = [];
        items.current.checkboxes = [];
        if (checked) {
            checkboxs.forEach(check => {
                check.checked = true;
                items.current.chosen.push(parseInt(check.value));
                items.current.checkboxes.push(check);
            })
        } else {
            checkboxs.forEach(item => {
                item.checked = false;
            })
        }
        setCheckedAll(checked)
        setCounter(items.current.chosen.length + "/" + items.current.showed.length)
        setActiveMassive(items.current.chosen.length > 0)
    }

    const handleCheck = (e) => {
        let checked = e.target.checked;
        let index = parseInt(e.target.value);
        if (checked) {
            items.current.chosen.push(index);
            items.current.checkboxes.push(e.target);
        } else {
            items.current.chosen = items.current.chosen.filter(item => item !== index);
            items.current.checkboxes = items.current.checkboxes.filter(ele => ele.value !== e.target.value);
        }
        if (items.current.chosen.length === items.current.showed.length) {
            setCheckedAll(true)
        }
        setActiveMassive(items.current.chosen.length > 0)
        setCounter(items.current.chosen.length + "/" + items.current.showed.length)
    }

    const updateAsset = (list, id, name, value) => {
        let assets_ = [...list];
        assets_.forEach(dyn => {
            if (dyn.asset_id === id) {
                dyn[name] = value;
            }
        });
        stepsTabs.setClassifyAssets(false);
        return assets_;
    }

    const handleChange = (e) => {
        let assetId = parseInt(e.target.dataset.asset);
        let name = e.target.dataset.name;

        let value = e.target.type === "checkbox"
            ? e.target.checked
            : parseInt(e.target.value);
        items.current.all = updateAsset(items.current.all, assetId, name, value);
        dynamicAssets.current = [...items.current.all];
        let showed_ = updateAsset(items.current.showed, assetId, name, value);
        items.current.showed = showed_;
        setDynamicAssetsShow(showed_);
    }

    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th style={{width: "32px"}}><input type="checkbox" name="all" checked={checkedAll} onChange={handleCheckAll}/></th>
                <th>
                    UID
                    <br/>
                    Dirección
                </th>
                <th style={{width: "70px"}}></th>
                <th>Grupo</th>
                <th>Isla</th>
                <th>Zona</th>
                <th>Rutas</th>
                <th>Ultima medición</th>
                <th style={{textAlign: "center"}}>Días sin vaciar</th>
                {CRITERIA.map((name) => (
                    <th key={name} style={{width: "50px", textAlign: "center"}} title={CRITERIA_TITLES[name]}>
                        {name.toUpperCase()}
                    </th>
                ))}
                <th style={{width: "60px", textAlign: "center"}}>Forzar</th>
                <th style={{width: "80px", textAlign: "center"}} title="Días desde el último vaciado (0 = no aplica)">Dias</th>
            </tr>
            </thead>
            <tbody id="dynamic-assets-table-body">
            {dynamicAssetsShow.map((item, index) => (
                <tr key={index}>
                    <td className="align-middle">
                        <input type="checkbox" className="index-select" value={item.asset_id} onChange={handleCheck}/>
                    </td>
                    <td>
                        <div>{item.asset.uid}</div>
                        <div>{item.asset.full_address}</div>
                        <small>{item.asset.uuids}</small>
                    </td>
                    <td className="text-end">
                        <div><IconFillingColoured value={item.asset.filling}/></div>
                        <div><IconTemperatureColoured value={item.asset.temperature}/></div>
                        <div>
                            {
                                item.asset.has_device
                                    ? <FontAwesomeIcon icon="wifi" title="Tiene sensor" className="text-secondary me-2"/>
                                    : <></>
                            }
                            {
                                item.asset.has_route
                                    ? <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" className="text-secondary"/>
                                    : <></>
                            }
                        </div>
                    </td>
                    <td>{item.asset.group_name}</td>
                    <td>{item.asset.island_name}</td>
                    <td>{item.asset.zone_name}</td>
                    <td>{item.asset.routes_name}</td>
                    <td>
                        {item.asset.measured_at ? moment(item.asset.measured_at).format("DD-MM-YYYY HH:mm") : "-"}
                    </td>
                    <td className="text-center" title={item.asset.unloaded_at ? moment(item.asset.unloaded_at).format("DD-MM-YYYY HH:mm") : ""}>
                        {item.asset.days_unloaded ?? "-"}
                    </td>
                    {CRITERIA.map((name) => (
                        <td key={name} className="text-center pt-3">
                            <input type="checkbox"
                                   data-name={name} data-asset={item.asset_id}
                                   checked={item[name]} onChange={handleChange}/>
                        </td>
                    ))}
                    <td className="text-center pt-3">
                        <input type="checkbox"
                               data-name="force" data-asset={item.asset_id}
                               checked={item.force} onChange={handleChange}/>
                    </td>
                    <td>
                        <input type="number" className="form-control text-end" min="0"
                               data-name="days" data-asset={item.asset_id}
                               value={item.days} onChange={handleChange}/>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    )
}
export default TabCriteriaTable;